import { notification } from 'antd'
import ApiEndPoints, { handelError, getLoggedInUserInfo } from 'utils'
import apiClient from '../index'

export const getPermissionsByDepId = async (depId, nestedRoleId) => {
  try {
    return await apiClient.get(`role`, {
      params: {
        depId,
        nestedRoleId,
      },
    })
  } catch (error) {
    notification.error({
      message: error?.message,
    })
  }
  return null
}
export const getPermissionsWithModules = () => apiClient.get('/modules/modulePermissions')
export const getGlobalTypeCategoryList = async (params) => {
  const { skip, limit, search } = params

  try {
    return await apiClient.get(ApiEndPoints.GLOBAL_TYPE_CATEGORY, {
      params: {
        skip,
        limit,
        search,
      },
    })
  } catch (error) {
    handelError(error)
  }
  return null
}
export const addRoleAndPermissions = async (values) => {
  try {
    return await apiClient.post('role', values)
  } catch (error) {
    notification.error({
      message: error?.message,
    })
  }
  return null
}

export const getMasterGlobalTypeList = async (value, options = {}) => {
  const { silent = false } = options

  try {
    return await apiClient.get(`${ApiEndPoints.MASTER_GLOBAL_TYPE_CATEGORY}${value}`, {
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}

export const getSingleMasterGlobalType = async (value) => {
  try {
    return await apiClient.get(`${ApiEndPoints.SINGLE_MASTER_GLOBAL_TYPE_CATEGORY}${value}`)
  } catch (error) {
    notification.error({
      message: error?.message,
    })
  }
  return null
}

export const getNestedGlobalType = async (pareentId, globalTypeValue) => {
  try {
    const response = await apiClient.get(
      `${ApiEndPoints.NESTED_GLOBAL_TYPE}${globalTypeValue}/${pareentId}`,
    )
    const nestedGlobalTypes = response?.data?.data

    if (Array.isArray(nestedGlobalTypes)) {
      response.data.data = nestedGlobalTypes.map((item) => ({
        ...item,
        GlobalType: item?.GlobalType || item?.childGlobalType,
      }))
    }

    return response
  } catch (error) {
    notification.error({
      message: error?.message,
    })
  }
  return null
}

export const getGlobalTypeList = async (params) => {
  const { skip, limit, globalTypeCategory, search } = params

  try {
    const response = await apiClient.get(`${ApiEndPoints.GLOBAL_TYPE}`, {
      params: {
        skip,
        limit,
        globalTypeCategory,
        search,
      },
    })
    return response
  } catch (error) {
    handelError(error)
  }
  return null
}
// This function is similar to getGlobalTypeList but with skip and limit set to 0
export const getGlobalTypeListAllList = async (params) => {
  const { globalTypeCategory, search } = params

  try {
    const response = await apiClient.get(`${ApiEndPoints.GLOBAL_TYPE}`, {
      params: {
        skip: 0,
        limit: 0,
        globalTypeCategory,
        search,
      },
    })
    return response
  } catch (error) {
    handelError(error)
  }
  return null
}
export const saveGlobalTypeCategory = async (data) => {
  try {
    return await apiClient.post(`${ApiEndPoints.GLOBAL_TYPE_CATEGORY}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const updateGlobalTypeCategory = async (data, id) => {
  try {
    return await apiClient.put(`${ApiEndPoints.GLOBAL_TYPE_CATEGORY}${id}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const saveGlobalType = async (data) => {
  try {
    return await apiClient.post(`${ApiEndPoints.GLOBAL_TYPE}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const updateGlobalType = async (data, id) => {
  try {
    return await apiClient.put(`${ApiEndPoints.GLOBAL_TYPE}${id}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getAllRoles = async () => {
  try {
    const response = await apiClient.get(`${ApiEndPoints.MASTER_GLOBAL_TYPE_CATEGORY}user_role`)
    return response
  } catch (error) {
    notification.error({
      message: error?.message,
    })
  }
  return null
}

export const staticContent = async (data) => {
  const { title, content } = data
  const empCode = getLoggedInUserInfo()?.empCode
  try {
    return await apiClient.post('staticContent', {
      empCode,
      title,
      content,
    })
  } catch (error) {
    if (error?.response?.status) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getStaticContent = async (title) => {
  const empCode = getLoggedInUserInfo()?.empCode
  let url = `staticContent/getStaticContent?empCode=${empCode}`
  if (title) {
    url += `&title=${title}`
  }
  try {
    return await apiClient.get(url)
  } catch (error) {
    if (error?.response?.status) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const getCompanyProfileList = async (params = {}, options = {}) => {
  const { skip = 0, limit = 10 } = params
  const { silent = false } = options

  try {
    const response = await apiClient.get(ApiEndPoints.COMPANY_PROFILE, {
      params: {
        skip,
        limit,
      },
      suppressErrorNotification: silent,
    })

    const companyCode =
      response?.data?.data?.companyProfile?.[0]?.company_code ||
      response?.data?.data?.companyProfile?.company_code ||
      response?.data?.data?.company_code ||
      response?.data?.company_code

    if (typeof window !== 'undefined' && typeof companyCode === 'string' && companyCode.trim()) {
      window.localStorage.setItem('currentCompanyCode', companyCode.trim().toUpperCase())
    }

    return response
  } catch (error) {
    if (!silent) {
      handelError(error)
    }
  }

  return null
}

export const saveCompanyProfile = async (data) => {
  try {
    return await apiClient.post(`${ApiEndPoints.COMPANY_PROFILE}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }

  return null
}

export const updateCompanyProfile = async (data, id) => {
  try {
    return await apiClient.put(`${ApiEndPoints.COMPANY_PROFILE}${id}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }

  return null
}

export const emailExists = async (email) => {
  try {
    return await apiClient.get(
      `${ApiEndPoints.CHECK_EMPLOYEE_EMAIL}/${encodeURIComponent(email)}`,
      {
        suppressErrorNotification: true,
      },
    )
  } catch (error) {
    return error
  }
}
export const deleteChildGlobalTypeCategory = async (parentId, childCategoryName) => {
  try {
    return await apiClient.delete(
      `globalType/global-type/${parentId}/child-category/${childCategoryName}`,
    )
  } catch (error) {
    notification.error({
      message: 'Error',
      description: error?.response?.data?.message || 'Failed to delete child category mapping',
    })
  }
  return null
}
export const getGlobalTypeById = async (id) => {
  try {
    const response = await apiClient.get(`globalType/global-type/${id}`)
    return response
  } catch (error) {
    handelError(error)
  }
  return null
}

export const updateGlobalTypeById = async (id, data) => {
  try {
    return await apiClient.put(`globalType/update-global-type/${id}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
